import React, { useState } from 'react';
const faqs = [{
  q: 'Ist es für Hatha und Vinyasa geeignet?',
  a: 'Ja, das System umfasst sowohl statische als auch dynamische Sequenzen, mit spezifischen Varianten für Hatha, Vinyasa und therapeutisches Yoga.'
}, {
  q: 'Erhalte ich die Boni zum Preis von 27 €?',
  a: 'Ja, alles ist im Paket enthalten, wenn Sie jetzt während des Launch-Angebots kaufen. Die 6 exklusiven Boni (Wert 149 €) sind komplett gratis.'
}, {
  q: 'Kann ich es als Anfänger-Lehrer nutzen?',
  a: 'Absolut. Es bietet Ihnen die Struktur, die oft am Anfang fehlt — mit progressiven Sequenzen vom Anfänger- bis zum Fortgeschrittenen-Level und klaren pädagogischen Leitlinien.'
}, {
  q: 'In welchem Format erhalte ich das Material?',
  a: 'Hochauflösende PDFs, optimiert zum Lesen auf Tablet oder Smartphone oder zum Ausdrucken im A4-Format zum Mitnehmen in den Kursraum. Keine spezielle Software erforderlich.'
}, {
  q: 'Ist die Zahlung sicher?',
  a: 'Ja, wir verwenden zu 100% verschlüsselte und sichere Gateways. Wir akzeptieren Kredit- und Debitkarten sowie die wichtigsten deutschen Zahlungsmethoden.'
}, {
  q: 'Wie lange habe ich Zugriff auf das Material?',
  a: 'Lebenslanger Zugriff. Einmal heruntergeladen, gehört das Kit zu 100% Ihnen — ohne Abonnements, ohne wiederkehrende Zahlungen, ohne Verfallsdatum.'
}, {
  q: 'Gibt es eine Geld-zurück-Garantie?',
  a: 'Ja, Sie haben 30 Tage volle Garantie. Wenn es Sie nicht überzeugt, erstatten wir Ihnen 100% Ihres Geldes ohne Fragen und ohne komplizierte Prozeduren.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-137">
          Häufig gestellte Fragen
        </h2>

        <div className="space-y-4 mb-16" data-id="element-138">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-139">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-140">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-141">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-142">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-143">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-144">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-145">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-146"></div>
          <a href="#pricing" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Yoga-Bereit — Das Komplett-Kit',
              content_type: 'product',
              value: 27,
              currency: 'EUR'
            });
          }
        }} className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-147">
            🚀 JA! ICH WILL MEINEN UNTERRICHT JETZT AUFS NÄCHSTE LEVEL HEBEN
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-148">
            <span data-id="element-149">⚡ Sofortiger Zugriff</span>
            <span data-id="element-150">•</span>
            <span data-id="element-151">🛡️ 30 Tage Garantie</span>
          </p>
        </div>
      </div>
    </section>;
}